import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  ERROR_NAME_NETWORK,
  ERROR_NAME_SERVER,
  ERROR_NAME_VALIDATION
} from '@/constants/settings'
import { mapActions, mapState, mapGetters } from 'vuex'
import { ERRORS, LOCALIZATION, SYSTEM_SETTINGS } from '@/constants/store.js'
import { URL_SYSTEM } from '@/constants/urls.js'
import { THEME_TYPES } from '@/constants/business'

const { isNavigationFailure, NavigationFailureType } = VueRouter

const commonMixin = {
  computed: {
    ...mapState({
      // состояния мапятся с указанием not-namespaced модуля, в котором их нужно искать
      // for state from not-namespaced modules
      generalError: state => state[ERRORS.NAMESPACE][ERRORS.STATE.GENERAL_ERROR]
    }),
    ...mapState(SYSTEM_SETTINGS.NAMESPACE, {
      isTestMode: SYSTEM_SETTINGS.STATE.IS_TEST_MODE,
      localizationEnabled: SYSTEM_SETTINGS.STATE.LOCALIZATION_ENABLED,
      configuration: SYSTEM_SETTINGS.STATE.CONFIGURATION,
      documentTemplatesMappings: state => state[SYSTEM_SETTINGS.STATE.DOCUMENT_TEMPLATES_MAPPINGS] || []
    }),
    ...mapState(LOCALIZATION.NAMESPACE, {
      systemLocale: LOCALIZATION.STATE.LOCALE
    }),
    ...mapGetters(SYSTEM_SETTINGS.NAMESPACE, {
      serverTime: SYSTEM_SETTINGS.GETTERS.SERVER_TIME
    }),
    segmentConfig () {
      const segmentProps = this.configuration.segment || []
      const segmentConfig = {}
      segmentProps.forEach(sp => {
        const value = sp.dataType === 'string'
          ? sp.stringValue
          : sp.dataType === 'dateTime'
            ? sp.dateValue
            : null

        segmentConfig[sp.propertyName] = value
      })
      return segmentConfig
    },
    themes () {
      const themeProps = this.configuration.themeProps || []
      const themeConfig = {
        [THEME_TYPES.LIGHT]: {},
        [THEME_TYPES.DARK]: {}
      }
      themeProps.forEach(sp => {
        themeConfig[sp.theme][sp.propertyName] = sp.value
      })
      return themeConfig
    },
    isDevEnv () {
      return Vue.getEnvironmentName() === 'development'
    },
    controlLocale () {
      return this.systemLocale === 'ru'
        ? 'ru-ru'
        : 'en-us'
    },
    urlRootPath () {
      return `/${this.systemLocale}${this.isAdmin ? '/admin' : ''}`
    }
  },
  methods: {
    ...mapActions({
      hideErrorAction: ERRORS.ACTIONS.HIDE_ERROR,
      showErrorAction: ERRORS.ACTIONS.SHOW_ERROR
    }),
    ...mapActions(SYSTEM_SETTINGS.NAMESPACE, {
      getConfigurationAction: SYSTEM_SETTINGS.ACTIONS.GET_CONFIGURATION
    }),
    focusOnBtn: function (refName) {
      this.$nextTick(() => {
        this.$refs[refName].$el.focus()
        if (this.$refs[refName].$refs.btn) {
          this.$refs[refName].$refs.btn.$el.focus()
        }
      })
    },
    goToRoute: function (routePath) {
      if (this.$route.path !== routePath) {
        this.$router.push({ path: routePath })
          .catch(error => {
            if (isNavigationFailure(error, NavigationFailureType.redirected)) {
              console.log(`Message: ${error.message}`)
              console.log(`From: ${error.from.path}`)
              console.log(`To: ${error.to.path}`) // '/admin'
              throw error
            // '/'
            }
          })
      }
    },
    replaceCurrentRoute: async function (routePath) {
      if (this.$route.path !== routePath) {
        await this.$router.replace({ path: routePath })
      }
    },
    closeDialog: function (objectName) {
      if (this[objectName]) {
        Object.keys(this[objectName]).forEach(key => {
          this[objectName][key] = key === 'show' ? false : null
        })
      }
    },
    throwIfUnknownError: function (error) {
      if (error.name !== ERROR_NAME_VALIDATION &&
      error.name !== ERROR_NAME_SERVER &&
      error.name !== ERROR_NAME_NETWORK) {
        throw error
      }
      if (error.name === ERROR_NAME_VALIDATION) {
        // отображаем ошибку
        this.showErrorAction({
          message: this.$t(error.message)
        })
      }
    },
    throwIfNotValidationError: function (error) {
      // если не ошибка валидации, то пробрасываем
      if (error.name !== ERROR_NAME_VALIDATION) {
        throw error
      }
      // отображаем ошибку
      this.showErrorAction({
        message: this.$t(error.message)
      })
    },
    throwIfNotServerError: function (error) {
      if (error.name !== ERROR_NAME_SERVER &&
      error.name !== ERROR_NAME_NETWORK) {
        throw error
      }
    },
    getDocumentTemplateName: function (docType, suffix) {
      const key = suffix ? `${docType}_${suffix}` : docType
      return this.documentTemplatesMappings[key] || null
    },
    getSystemFileUrl: function (fileName) {
      return `${Vue.getBusinessHost()}${URL_SYSTEM}/file/${fileName}?${Vue.helpers.getQueryParamsString()}`
    },
    getConfiguration: async function () {
      try {
        await this.getConfigurationAction()

        if (this.themes[THEME_TYPES.LIGHT]?.primary) {
          for (const prop in this.themes[THEME_TYPES.LIGHT]) {
            this.$vuetify.theme.themes[THEME_TYPES.LIGHT][prop] = this.themes[THEME_TYPES.LIGHT][prop]
          }
        }
        if (this.themes[THEME_TYPES.DARK]?.primary) {
          for (const prop in this.themes[THEME_TYPES.DARK]) {
            this.$vuetify.theme.themes[THEME_TYPES.DARK][prop] = this.themes[THEME_TYPES.DARK][prop]
          }
        }
      } catch (error) {
        this.throwIfNotServerError(error)
      }
    }
  }
}

export default commonMixin
